// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__GsUh_","errors":"Errors_errors__GimxC"};